import { ReactNode } from "react";
import PageLayer from "@/Layouts/views/PageLayer";
import Wrapper from "./Wrapper";
import { ICommissionCycle, IPayPeriod } from "@/Common/api/types/CommissionCycle";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/washouts/WashoutReview.svg";

type TLayerProps = {
	title: ReactNode;
	onUpdateTitle: (cycle?: ICommissionCycle, payPeriod?: IPayPeriod) => void;
};
const Layer = (props: Readonly<TLayerProps>) => {
	const { title = "", onUpdateTitle = () => {} } = props;

	return (
		<PageLayer
			title={title}
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon
						viewBox="-2 -2 24 24"
						className="text-[var(--light-blue-color)] [&>path]:!fill-[var(--light-blue-color)] !text-[27px]"
						component={Icon}
					/>
				</Stack>
			}
		>
			<Wrapper onUpdateTitle={onUpdateTitle} />
		</PageLayer>
	);
};

export default Layer;
